module.exports = __webpack_public_path__ + "img/phone_2.23d104cb.png";